import { render, staticRenderFns } from "./CreateCaseModal.vue?vue&type=template&id=62b5defa&scoped=true&"
import script from "./CreateCaseModal.vue?vue&type=script&lang=js&"
export * from "./CreateCaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5defa",
  null
  
)

export default component.exports